import { NavLink, Outlet } from "react-router-dom";

export default function AutomationAdmin() {
  const tabClass = ({ isActive }) =>
    [
      "px-4 py-2 border-b-2 text-sm font-medium",
      isActive
        ? "border-blue-600 text-blue-600"
        : "border-transparent text-gray-600 hover:text-gray-900",
    ].join(" ");

  return (
    <div className="p-6 max-w-6xl">
      <div className="mb-6">
        <h1 className="text-2xl font-semibold">Automation</h1>

        <p className="text-sm text-gray-600 mt-1">
          Manage automatic rules, technician recipes and notification templates.
        </p>
      </div>

      <div className="flex gap-2 border-b mb-6">
        <NavLink
          to="/helpdesk/automation/rules"
          className={tabClass}
        >
          Rules
        </NavLink>

        <NavLink
          to="/helpdesk/automation/recipes"
          className={tabClass}
        >
          Recipes
        </NavLink>

        <NavLink
          to="/helpdesk/automation/notifications"
          className={tabClass}
        >
          Notifications
        </NavLink>
      </div>

      <Outlet />
    </div>
  );
}